/*
  How the Eye Works JS - Davidwilliams March / April 2015  
*/

/* Grab each .staticSlide and build a Javascript object containing slide information and content */
function buildJavascriptOb() {
  $(".staticSlide").each(function( index ) {
    var slide = {};
    slide.zoomFromSide = $(this).data("zoom-from-side");
    slide.slideTitle = $.trim($(this).find(".staticSlideTitle").text());
    slide.slideImg = $(this).find(".staticSlideImg").attr("src");
    slide.slideImgAlt = $(this).find(".staticSlideImg").attr("alt");
    slide.wobbleImg = $(this).data("wobble-img");   
    slide.wobbleImgAlt = $(this).data("wobble-img-alt");  
    slide.wobbleImgId = $(this).data("wobble-img-id");   
    slide.infoPoints = [];
    $(this).find(".staticInfoPoint").each(function(index) {
      var infoPoint = $(this);
      var infoPointOb = {}
      infoPointOb.pointTitle = $.trim(infoPoint.find(".staticInfoPointTitle").text());
      infoPointOb.altPosition = infoPoint.data("alt-position");
      infoPointOb.positionL = infoPoint.data("position-l");
      infoPointOb.positionT = infoPoint.data("position-top");
      infoPointOb.briefTitle = $.trim(infoPoint.find(".staticBriefTitle").text());
      infoPointOb.briefText = $.trim(infoPoint.find(".staticBriefText").text());
      infoPointOb.infoPointHTML = $.trim(infoPoint.find(".staticInfoPointHTML").html());      
      slide.infoPoints.push(infoPointOb);     
    });
    slides.push(slide);
  }); 
}

/* show / hide #embedLink's content onclick */
function bindEmbedLinkClick() {
  $(".embedLink").on({ 
    'click.htew' : function(e) {
      e.preventDefault();
      e.stopPropagation();
      if($(this).data("isOpen")) {
        hideEmbedContent($(this));
      } else {
        showEmbedContent($(this));
      }
	  }
	});  
}

function showEmbedContent(embedLink) {
  trackEvent("embedLink", "open");
  embedLink.data("isOpen", true);
  hideInfoPoints();
  embedLink.closest(".embedBox").find(".embedLinkContent").show();
  unbindBodyClick();
  bindBodyClick();
}

function hideEmbedContent(embedLink) {
  embedLink.data("isOpen", false);
  embedLink.closest(".embedBox").find(".embedLinkContent").hide();
  unbindBodyClick();
}
function hideAllEmbedContents() {
  $(".embedLink").data 
  $(".embedLink").each(function( index ) {
    hideEmbedContent($(this));
  });
}
function bindEmbedCodeClick() {
  $(".embedCode").on({
    'click.htew' : function(e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).focus().select();
    }
  }); 
}
function createSlideContent() {
  var $slidecontainer = $('#slideContainer');  
  var $tableOfContentsAccordion = $("#tableOfContentsAccordion");  
  var $infoPaneContent = $("#infoPaneContent");
  
  /* Iterate through slides, a JS object constructed in buildJavascriptOb() - use it to create the interactive content and behaviour */
  for(var i in slides) {
    var slide = slides[i];
    var slideHTML = $('<div class="slide"></div>');
    slideHTML.data(
      {
        "zoom-from-side": slide.zoomFromSide, 
        "slide-title": slide.slideTitle, 
        "wobble-img": slide.wobbleImg, 
        "wobble-img-alt": slide.wobbleImgAlt,
        "wobble-img-id": slide.wobbleImgId
      }
    );
    var slideImg = $('<img src="'+slide.slideImg+'" alt="'+slide.slideImgAlt+'" />');
    slideHTML.append(slideImg);
    
    if(slideHTML.data("wobble-img")) {
      slideHTML.append($('<img class="wobbleImage" src="skins/Lenstore/styleImages/howyoureyeswork/slideImages/'+slideHTML.data("wobble-img")+'" alt="'+slideHTML.data("wobble-img-alt")+'" id="'+slideHTML.data("wobble-img-id")+'" />'));
    } 
    
    // Todo: Create a p.contentAccordionHeader width a slideId
    var tableOfContents = $('<p class="contentAccordionHeader">'+slide.slideTitle+'</p>');
    $tableOfContentsAccordion.append(tableOfContents);
    
    var contentListHTML = $('<ul class="contentList"></ul>');
    
    var infoPoints = slide.infoPoints;
    
    for(var j in infoPoints) {
      var infoPoint = infoPoints[j]; 
      var pointHTML = $('<div class="slideInfoUnit" data-pos-left="'+infoPoint.positionL+'" data-pos-top="'+infoPoint.positionT+'" data-accordion-block-id="'+i+'" data-point-title="'+infoPoint.pointTitle+'"></div>');
      pointHTML.append($('<p class="slideInfoPoint" ></p>'));
      var pointHTMLContent = $('<div class="slideInfoText"></div>');
      
      if(infoPoint.altPosition) {
        if(infoPoint.altPosition == "right") {
          pointHTMLContent.addClass("slideInfoTextRight");
        } else if (infoPoint.altPosition == "rightBottom") {
          pointHTMLContent.addClass("slideInfoTextRightBottom");          
        } else if (infoPoint.altPosition == "leftBottom") {
          pointHTMLContent.addClass("slideInfoTextLeftBottom");          
        }
      }
      pointHTMLContent.append($('<h2 class="slideInfoTitle">'+infoPoint.briefTitle+'</h2>'));     
      pointHTMLContent.append($('<p class="slideInfoBriefText">'+infoPoint.briefText+'<span class="slideMoreInfo">Learn More</span></p>')); 
      pointHTML.append(pointHTMLContent);
      
      var infoPaneContentItem = $('<div class="infoPaneContentItem" data-slide-title="'+slide.slideTitle+'" data-point-title="'+infoPoint.pointTitle+'"></div>');
      
      var takeMeButton = $('<p class="takeMeButton" title="Take me to '+infoPoint.pointTitle+'">Take Me There</p>');
      takeMeButton.data({"slideId": i, "infoUnit": pointHTML });
      infoPaneContentItem.append(takeMeButton);
      
      infoPaneContentItem.append($('<h2>'+infoPoint.pointTitle+'</h2>'));
      infoPaneContentItem.append(infoPoint.infoPointHTML);
      pointHTML.data("content-list-html", infoPaneContentItem);
      $infoPaneContent.append(infoPaneContentItem);

      var contentListItem = $('<li class="contentListItem" data-content-slide-id ="'+i+'">'+infoPoint.pointTitle+'</li>');
      pointHTML.data("content-list-item", contentListItem);
      contentListItem.data("content-list-html", infoPaneContentItem);
      contentListHTML.append( contentListItem );  
      pointHTML.data("content-list-item", contentListItem);
    
      
      
      
      $(slideHTML).append($(pointHTML))
    }
    
    $tableOfContentsAccordion.append($(contentListHTML)); 
    
    $slidecontainer.append($(slideHTML))
  }
}




function zoomIn() {
  var targetSlide = parseInt(currentSlideId) + 1;
  zoom(targetSlide);
  trackEvent("nextSlide", targetSlide);
}
function zoomOut() {
  var targetSlide = parseInt(currentSlideId) - 1;
  zoom(targetSlide);
  trackEvent("previousSlide", targetSlide);
}
function zoom(newSlideId) {
  updateSlideshow(newSlideId);
}



// Display whichever slide's id matches the value of the slider
function updateSlideshow(newSlideId) {
  if( !$("body").data("slideLocked") && currentSlideId != newSlideId && newSlideId >= 0 && newSlideId < $(".slide").length) {
    $("body").data("slideLocked", true);
    fadeOutInfoUnits();
    
    var $currentSlide = $(".slide").eq(currentSlideId);
    var $newSlide = $(".slide").eq(newSlideId);
    
    $newSlide.show().css("z-index", 0);
    var goForward;
    if(currentSlideId < newSlideId) {
      goForward = true;
    } else {
      goForward = false; 
    }
    enableDisableNavlinks(newSlideId);
    if($currentSlide.data("zoom-from-side") == "right") {
      // Set right to 0 and left to auto, so the slide expands out to the left. We don't need to change any values here if we want to expand out to the right
      $currentSlide.css({"left": "auto", "right": "0"});
    }
    
    $currentSlide.fadeOut(
      {
        duration: 1000,
        easing: "easeInOutCubic",
        step: function() {
          // Calculate current vals
          var stepWidth = $(this).width();
          var stepHeight = $(this).height();
          var stepLeft = parseInt($(this).css("left"));
          var stepTop = parseInt($(this).css("top"));    
          
          // Calculate updated slide dimensions, according to whether we're growing or shrinking it, and according to whether it is set to zoom in from one side.

          if(goForward) {    
            // calculate new dimensions and top position
            var newWidth = stepWidth + 16;
            var newHeight = stepHeight + 8;
            var newTop = ( stepTop - 4 )+"px";
            // set new dimensions and top position
            $(this).width(newWidth);
            $(this).height(newHeight);
            $(this).css("top",newTop);
                        
            if($currentSlide.data("zoom-from-side") != "right" && $currentSlide.data("zoom-from-side") != "left") {
              // subtract from the left value at a constant rate, to keep the slide centrally aligned.
              var newLeft = ( stepLeft - 8 )+"px";
              $(this).css("left",newLeft);     
            }    
          }
  			},
  			complete: function(){
  			  // Reset slide height and width to default once hidden
          fadeInInfoUnits();
          $(this).width(slideWidth).height(slideHeight).css({ "left": "0", "top": "0", "right": "auto" });
          $newSlide.css("z-index", 1);
          if($newSlide.data("wobble-img")) {
            wobbleImg($newSlide.data("wobble-img-id")); 
          }
          if($newSlide.index(".slide") == $(".slide").length - 1) {
            setTimeout(
            function(){ 
              if(!$newSlide.data("outroDisplayed")) {
                $newSlide.append($("#outroContent"))
                $("#outroContent").css({"left": "0", "display": "none", "position": "relative"}).fadeIn();
                $newSlide.data("outroDisplayed", true);
              }
            }, 2000);
          }
          currentSlideId = newSlideId;
          $("body").data("slideLocked", false);
    		}
  		}
  	);   	
  }
}

function enableDisableNavlinks(slideId) {  
  if(slideId <= 0  ) {
    $("#navLeft").fadeOut();
  } else {
    $("#navLeft").fadeIn();
  }
  if(slideId >= ($(".slide").length -1)) {
    $("#navRight").fadeOut();
  } else {
    $("#navRight").fadeIn();
  }
}

function disableNavLinks() {
  $(".navLink").fadeOut(); 
}

// Bind click events to each infoPoint to show / hide its associated infoText
function setupInfoPoints() {
  positionInfoUnits();
  bindInfoPointsClick();
  bindMoreInfoClick();
  bindContentListItemClick();
  bindTakeMeThereButtons();
}

function bindInfoPointsClick() {  
  $(".slideInfoPoint").on({ 
    'click.htew' : function(e) {
      e.preventDefault();
      e.stopPropagation();
      
	    var $closestUnit = $(this).closest(".slideInfoUnit");
	    var $closestSlide = $closestUnit.closest(".slide");
	    trackEvent("infoClick", "Slide: "+$closestSlide.data("slide-title")+" | infoPoint: "+$closestUnit.data("point-title") ); 
	    
	    showHideInfoPoint($(this));
	  },
	  'mouseover.htew' : function(e) {
	    var $closestUnit = $(this).closest(".slideInfoUnit");
	    var $closestSlide = $closestUnit.closest(".slide");
	    trackEvent("infoHover", "Slide: "+$closestSlide.data("slide-title")+" | infoPoint: "+$closestUnit.data("point-title") ); 
	  }
	}); 
}

function showHideInfoPoint(infoPoint) {
  var infoUnit = infoPoint.closest(".slideInfoUnit");
  if(infoPoint.data("open")) {
    infoUnit.find(".slideInfoText").hide();
    infoUnit.css("z-index", 1);
    infoPoint.data("open", false);
    unbindBodyClick();
  } else {
    // hide all infotexts and mark open as false
    hideInfoPoints();
    hideAllEmbedContents();
    infoPoint.data("open", true);
    infoUnit.css("z-index", 3);
    infoUnit.find(".slideInfoText").show();
    unbindBodyClick();
    bindBodyClick();
  }
}

function hideInfoPoints() {
  $(".slideInfoText").hide();
  $(".slideInfoPoint").data("open", false);
  $(".slideInfoUnit").css("z-index", 1);
}

function bindBodyClick() {
  // And now add a listener to the body, to close all slideInfoTexts on click.
  $("body").on({
    'click.htew' : function(e) { 
      e.preventDefault();
	    e.stopPropagation();
      hideInfoPoints();
      hideAllEmbedContents();
      unbindBodyClick();
    }
  }); 
}

function unbindBodyClick() {
  $("body").off("click.htew");
}

function bindSlideContainerClick() {
  $("#slideContainer"). on({
    'click.htew' : function(e) {
	    e.preventDefault();
	    e.stopPropagation(); 
	    if(!$(e.target).closest('#infoPane').length){
        slideOutPanel();
      }	    
    }
  }); 
}

function unBindSlideContainerClick() { 
  $("#slideContainer").off("click.htew");
}


function bindMoreInfoClick() {
  $(".slideMoreInfo").on({
    'click.htew' : function(e) {   
      var parentalUnit = $(this).closest(".slideInfoUnit");
      var accordionBlockId = $(this).closest(".slideInfoUnit").data("accordion-block-id");  
	    e.preventDefault();
	    e.stopPropagation(); 
	    // Slide out the panel
	    
	    var $closestUnit = $(this).closest(".slideInfoUnit");
	    var $closestSlide = $closestUnit.closest(".slide");
	    trackEvent("moreInfoClick", "Slide: "+$closestSlide.data("slide-title")+" | infoPoint: "+$closestUnit.data("point-title") );
	    
	    hideInfoPoints();
      $(".infoPaneContentItem").hide();
      
      var contentListItem = parentalUnit.data("content-list-item");
      
      markListItemAndShowContent(contentListItem); 
      
	    slideInPanel(accordionBlockId);
	    unbindBodyClick();
	    bindSlideContainerClick();
    }
  }); 
}

function bindContentListItemClick() {
  $(".contentListItem").on({
    'click.htew' : function(e) {   
      markListItemAndShowContent($(this))
    }
  });
}

function showInfoPaneContentItem(contentItem) {
  $(".infoPaneContentItem").hide();
  contentItem.show().focus();
  $("#infoPaneContent").scrollTop(0);
}

function markListItemSelected(listItem) {
  $(".contentListItem").removeClass("selectedContentListItem");
  listItem.addClass("selectedContentListItem");
}

// Pass the list item, which we mark as selected, and display its related HTML block.
function markListItemAndShowContent(contentItem) {
  showInfoPaneContentItem(contentItem.data("content-list-html"));
  markListItemSelected(contentItem);
}

// Iterate through each slideInfoUnit. Set left and top values as percentages using their data-pos-left and data-pos-top values.
function positionInfoUnits() {
  $( ".slideInfoUnit" ).each(function( index ) {
    leftPos = $(this).data("pos-left");
    topPos = $(this).data("pos-top");
    $(this).css({"left": leftPos+"%", "top": topPos+"%"}).show();
  }); 
}

function slideInPanel(accordionBlockId) {
  if (typeof(accordionBlockId) == 'undefined') {
		accordionBlockId = 0;
	}
  fadeOutInfoUnits();
  disableNavLinks();
  openAccordionToBlock(accordionBlockId);
  $("#infoPane").show("slide", { direction: "right" }, 1000);
}

function slideOutPanel() {
  unBindSlideContainerClick();
  enableDisableNavlinks(currentSlideId);
  fadeInInfoUnits()
  $("#infoPane").hide("slide", { direction: "right" }, 1000);
}

function openAccordionToBlock(blockIndex) {
  $("#tableOfContentsAccordion").accordion("option","active",blockIndex);
}

function fadeInInfoUnits() { 
  $(".slideInfoUnit").fadeIn(
    {
      duration: "fast"
    }
  );
}

function fadeOutInfoUnits() {
  $(".slideInfoUnit").fadeOut(
    {
      duration: "fast",
      complete: function() {
        //hideInfoPoints(); 
      }
    }
  );
}

function collapseTableOfContents() {
  // Temporarily switch infopane to display block, visibility hidden so elements have width and height when we load the accordion
  $("#infoPane").css("visibility", "hidden").show();
  $("#tableOfContentsAccordion").accordion({
    header: "p.contentAccordionHeader",
    collapsible: true,
    icons: { 
      "header": "ui-icon-triangle-1-e", 
      "activeHeader": "ui-icon-triangle-1-s" 
    },
    heightStyle: "content"
  });
  $("#infoPane").hide().css("visibility", "visible");
}

function bindTakeMeThereButtons() {
  $(".takeMeButton").on({
    'click.htew' : function(e) { 
      e.preventDefault();
      e.stopPropagation();
      
	    var $closestPaneContent = $(this).closest(".infoPaneContentItem");
	    var $infoUnit = $(this).data("infoUnit");
	    trackEvent("takeMeThere", "Slide: "+$closestPaneContent.data("slide-title")+" | infoPoint: "+$infoUnit.data("point-title") ); 
	    
      slideOutPanel();
      updateSlideshow($(this).data("slideId"));
      showHideInfoPoint($(this).data("infoUnit").find(".slideInfoPoint"));
    }
  });
}
function displayAndBindIntroBox() {
  disableNavLinks();
  displayIntroBox();
  bindIntroBox(); 
}
function displayIntroBox() {
  $("#slideContainer").append($("#introContent"));
  $("#introContent").show();
}

function bindIntroBox() {
  $("#startTour").on({
    'click.htew' : function(e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).closest(".introContent").fadeOut();
      enableDisableNavlinks(currentSlideId);
    }
  });
}

// Google Analytics event tracking

function trackEvent(actionName, labelName) {
  if(typeof ga != 'undefined') {
		ga('send', 'event', 'how-the-eye-works', actionName, labelName, 1);
	} 
}

function addFBTracking() {
	if(typeof FB != 'undefined') {
	  FB.Event.subscribe('edge.create', function(targetUrl) {
	    trackEvent("socialShare", "facebookLike");
	  }); 
	  FB.Event.subscribe('edge.remove', function(targetUrl) {
	    trackEvent("socialShare", "facebookUnlike");
	  }); 
	}
}
function addPinterestTracking() {
  $(".pinterestBox a").on({
    'click.htew' : function(e) {
      trackEvent("socialShare", "pinterestClicked");
    }
  });
}
function addTwitterTracking() { 
  twttr.ready(function (twttr) {
    twttr.events.bind(
      'tweet',
      function (event) {
        trackEvent("socialShare", "twitterShare");
      }
    );
  }); 
}

// Wobbly image functionality

var xRange = 22;
var yRange = 8;
        
function getArbitraryNum(min, max) {
  var arbitraryNum = Math.random() * (max - min) + min;
  if(Math.random() < 0.5) {
    arbitraryNum = -Math.abs(arbitraryNum)
  }
  return arbitraryNum;
}

function makeNewPosition(leftPos, topPos){
  
  var randX = Math.floor(getArbitraryNum(1, xRange));
  var randY = Math.floor(getArbitraryNum(1, yRange));
  
  var xMin = leftPos - (xRange);
  var xMax = leftPos + (xRange);
  var yMin = topPos - yRange;
  var yMax = topPos + yRange;

  var nx = leftPos + randX;
  var ny = topPos + randY;

  return [nx, ny];
}

function wobbleImg(elementToAnimate, leftPos, topPos){
  var $el = $("#"+elementToAnimate);
  if(typeof(leftPos) == 'undefined') {
    leftPos = $el.position().left; 
  }
  if(typeof(topPos) == 'undefined') {
    topPos = $el.position().top; 
  }
  var newq = makeNewPosition(leftPos, topPos);
  
  
  var oldq = $el.position();
  
  $el.animate({ 
    left: newq[0], 
    top: newq[1] 
    },
    2000, 
    function(){
      wobbleImg(elementToAnimate, leftPos, topPos);
    }
  );        
}

// SVG replacement functionality


function svgSupported() {
	return document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image", "1.1");
}

/*
 * Fires within global templates on document.ready
 */
function enhanceWithSVG() {
	$( document ).ready(function() {
		if(svgSupported()) {
			replaceBGWithSVG();
			replaceImgWithSVG();
		}
	});
}
/*
 * 1. Grab any elements of class .svgBG
 * 2. Replace the background-image declaration  - .png and .gif are replaced with .svg
*/
function replaceBGWithSVG() {
	$(".svgBG").each(function( index ) {
		var backgroundImg = $(this).css("background-image");
		backgroundImg = backgroundImg.replace(".png", ".svg").replace(".gif", ".svg");
		$(this).css("background-image",backgroundImg);
	});
}

/*
 * 1. Grab any elements of class .svgImage
 * 2. Replace the image src  - .png and .gif are replaced with .svg
*/
function replaceImgWithSVG() {
	$(".svgImage").each(function( index ) {
		var imgFilename = $(this).attr("src");
		imgFilename = imgFilename.replace(".png", ".svg").replace(".gif", ".svg");
		$(this).attr("src", imgFilename);
	});
}